import { useState } from 'react';

import { XIcon } from '@zola/zola-ui/src/components/SvgIconsV3/X';

import { useSearchedLocation } from '~/contexts/SearchContext';
import type { LocationOrAllMarketsType } from '~/types/responseTypes';

import { Container, CloseButton, ScreenReaderText, StyledLabel } from './EditLocationModal.styles';
import LocationDropdown from './LocationDropdown';

export type EditLocationModalProps = {
  hideModalFn: () => void;
};

const EditLocationModal = ({ hideModalFn }: EditLocationModalProps): JSX.Element => {
  const [locationDropdownInput, setLocationDropdownInput] = useState('');
  const { setSearchedLocation } = useSearchedLocation();

  const handleSelection = (location: LocationOrAllMarketsType) => {
    hideModalFn();
    setSearchedLocation(location);
  };

  return (
    <Container>
      <CloseButton onClick={hideModalFn}>
        <XIcon height={24} width={24} />
        <ScreenReaderText>Close</ScreenReaderText>
      </CloseButton>
      <StyledLabel useLabel labelFor="location-dropdown" labelText="Location" />
      <LocationDropdown
        id="location-dropdown"
        selectedLocation={null}
        updateSelectedLocation={handleSelection}
        inputString={locationDropdownInput}
        setInputString={setLocationDropdownInput}
        selectedTaxonomyNode={null}
        shouldCloseDropdown
        shouldFocusOnMount
        isClpTest
        placeholder="Enter location"
      />
    </Container>
  );
};

export default EditLocationModal;
